<mat-form-field class="form-full-width" appearance="outline" [formGroup]="group">
    <i matPrefix *ngIf="field?.leadingIcon" [ngClass]="'mdi mdi-' + field?.leadingIcon" class="input_leading-icon"></i>
    <mat-label>{{ field.label }}</mat-label>
    <input
        matInput
        [formControl]="group.get(field.name)"
        [id]="field.id ? field.id : null"
        [app-restrict-input]="'date'"
        [app-restrict-input-control]="group.get(field.name)"
        [matDatepicker]="inputDatepicker"
        [matDatepickerFilter]="data?.dataFilter ?? dataFilter"
        (paste)="changeEvent($event)"
        (dateChange)="changeEvent(null)"
        [readonly]="field.disabled"
        [required]="field.required"
    />
    <mat-datepicker #inputDatepicker></mat-datepicker>
    <fui-button
        *ngIf="!field?.hideClearButton && group.get(field.name).value && !field.disabled && !field.is_block"
        (clickEvent)="clear()"
        matSuffix
        icon="close"
        [title]="appService.language_dictionary.system_clear"
        type="button-icon"
        borderRadius="circle"
        color="neutral"
        height="mini"
        [iconSize]="16"
        [disabled]="field.disabled"
    >
    </fui-button>
    <mat-datepicker-toggle matSuffix [for]="inputDatepicker" [tabIndex]="-1">
        <fui-button
            [disabled]="field.disabled || group.get(field.name)?.disabled"
            [title]="appService.language_dictionary.system_calendar"
            [ngClass]="'z-10'"
            matDatepickerToggleIcon
            icon="calendar"
            type="button-icon"
            color="neutral"
            height="mini"
            borderRadius="circle"
            iconSize="20"
        >
        </fui-button>
    </mat-datepicker-toggle>
    <fui-button
        matSuffix
        *ngIf="field?.trailingButton"
        (clickEvent)="outputEvent.emit({ action: field?.trailingButton?.action })"
        [ngClass]="'input_trailing-button'"
        [icon]="field?.trailingButton.icon"
        [title]="field?.trailingButton.title"
        [type]="'button-icon'"
        [borderRadius]="'circle'"
        [color]="'neutral'"
        [height]="'mini'"
        [disabled]="field.disabled"
    >
    </fui-button>
    <mat-hint *ngIf="field.hint" [innerHtml]="field.hint"></mat-hint>
    <ng-container *ngFor="let validation of field.validations" ngProjectAs="mat-error">
        <mat-error
            *ngIf="group?.get(field.name)?.hasError(validation.name)"
            [innerHTML]="
                validation.name === 'serverError' ? group?.get(field.name)?.errors?.serverError : validation.message
            "
        >
        </mat-error>
    </ng-container>
    <mat-error *ngIf="group.get(field.name).hasError('inputMaskError')">
        {{ group.get(field.name).errors?.inputMaskError }}
    </mat-error>
    <mat-error *ngIf="group.get(field.name).hasError('matDatepickerFilter')">
        {{ appService.language_dictionary.enter_the_correct_period }}
    </mat-error>
</mat-form-field>
